/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { CurriculumRouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import withApiError from 'layers/errorHandling/apiError'
import { navigationEvent } from 'layers/navigation/store/operations'
import { getPageTypeByUrl, pageTypes } from 'utils/routing/getPageTypeByUrl'
import {
  resolveRouteServiceApp,
  showSiteSelector,
  isHighSchoolUrl,
} from 'utils/routing/routeHelpers'
import {
  isPreviewMode,
  transformInstructorDataToOldShape,
} from 'utils/highschoolHelpers'
import { selectors as lmsSelectors } from 'store/lmsManager'

import TrainingLandingV3 from './component'

const mapSubsectionLanding = (entry, location, navigationEventFn) => {
  const { displayTitle, description, content = [] } = entry || {}

  const articles = content.map(article => {
    const { description: body, displayTitle: title, pageData } = article || {}
    const { image } = article || {}
    const { image: nestedImage, url: flatUrl } = image || {}
    const { url: nestedUrl } = nestedImage || {}
    const { route } = pageData || {}

    return {
      body,
      image: nestedUrl || flatUrl,
      link: route,
      location,
      navigationEvent: navigationEventFn,
      title,
    }
  })

  return {
    articles,
    banner: { text: description, title: displayTitle },
    isHsLanding: false,
  }
}

const mapNavigationPage = navigationPage => {
  const { linkSummaries = [], pageSummary } = navigationPage || {}
  const { description, displayTitle } = pageSummary || {}

  return {
    banner: { text: description, title: displayTitle },
    hsLinkSummaries: linkSummaries,
    isHsLanding: true,
  }
}

export const TrainingLandingV3Container = props => {
  const {
    instructorData,
    location,
    navigationEvent: navigationEventFn,
    routeContent,
    productTabTitle,
  } = props || {}

  const { content = {}, loading } = routeContent || {}
  const { subsectionLanding, navigationPage } = content
  const isHighSchool = isHighSchoolUrl()
  const hasNeededInstructorData =
    isPreviewMode() || !!instructorData || !isHighSchool
  const readyToLoad =
    !!content &&
    !loading &&
    hasNeededInstructorData &&
    (subsectionLanding || navigationPage)

  if (!readyToLoad) {
    return null
  }

  const pageType = getPageTypeByUrl(location?.pathname)
  const parsedEntry = navigationPage
    ? mapNavigationPage(navigationPage)
    : mapSubsectionLanding(subsectionLanding, location, navigationEventFn)

  const shouldShowSiteSelector = showSiteSelector()

  return (
    <TrainingLandingV3
      {...parsedEntry}
      instructorData={instructorData}
      isHsPreview={isPreviewMode()}
      navigationEvent={navigationEventFn}
      pageType={navigationPage ? pageTypes.HS_TRAINING_PAGE : pageType}
      productTabTitle={productTabTitle}
      shouldShowSiteSelector={shouldShowSiteSelector}
    />
  )
}

TrainingLandingV3Container.propTypes = {
  instructorData: PropTypes.object,
  location: PropTypes.object,
  navigationEvent: PropTypes.func,
  productTabTitle: PropTypes.string,
  routeContent: PropTypes.object,
}

const mapStateToProps = state => ({
  instructorData: transformInstructorDataToOldShape(
    lmsSelectors.selectHsInstructorData(state),
  ),
  productTabTitle: state.productManager?.productMap?.name || '',
})

const mapDispatchToProps = {
  navigationEvent,
}

export const trainingLandingV3CurriculumOptions = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

export const TrainingLandingV3Page = withSiteContext(
  CurriculumRouteContentGetter(
    withApiError(
      connect(mapStateToProps, mapDispatchToProps)(TrainingLandingV3Container),
    ),
    trainingLandingV3CurriculumOptions,
  ),
  { syncSiteQueryParam: false, useGuard: true },
)

export default TrainingLandingV3Page
